export const DEFAULT_LEAD_SOURCES = [
  'TV',
  'Streaming TV (Hulu, Roku, etc.)',
  'Search (Google, Bing, etc.)',
  'Podcast',
  'Facebook and/or Instagram',
  'Review Site',
  'Radio',
  'Friend and/or Family',
  'YouTube Influencer',
  'Email Newsletter',
  'Streaming Audio (Spotify, Pandora, etc.)',
  'Retail Stores (Amazon, Best Buy, etc.)',
  'American Express',
  'Mail',
  'TikTok',
  'Employee Benefit Program',
  'Neighbourhood Watch',
  'Other'
]
